import { getCustomerClient } from '@/src/lib/customer/requests/get-customer.client';
import { deserializeCollection } from '@/src/lib/http/jsonapi/deserializer';
import { Customer } from '@/src/lib/customer/types';

export async function isCustomerVerified(): Promise<boolean> {
  try {
    const customer = await getCustomerClient();

    const deserializedCustomer = deserializeCollection<Customer>(customer);

    return deserializedCustomer[0].isVerified;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Couldn\'t get customer', e);
    return false;
  }
}
